module.exports = __webpack_public_path__ + "h5/img/medal02.326c83e2.png";